import React from "react";
import {
    FormTab,
    Tab,
    RichTextField,
    TextField,
    useResourceContext

} from "react-admin";
import { Typography, Box, Divider, Chip } from '@mui/material';
import { AutocompleteInput, RichTextInput } from "../../../lib/wrappers/Inputs";
import { VersioningTypeInput } from "../../../lib/VersioningTypeInput";

var titleStyle = { color: "#AE223F" }
var labelStyle = {
    color: '#000000',
    opacity: 0.8,
    padding: 0,
    fontsize: 1,
    fontweight: 400, lineheight: 1, letterspacing: 0.00938
}


export const CourseQualityAssuranceArrangementsInputTab = (source) => {
    const resource = useResourceContext();
    return <FormTab label="Course QAA" {...source} >
        <Box flex={4} sx={{ paddingBottom: '20px' }}>
            <Typography variant="h6" style={titleStyle}>
                Course | <small><TextField source="id" label={false} /></small> | <small><TextField source="courseCode" label={false} /></small>
            </Typography>
        </Box>
                <Box display="flex" width={1}>
                    <Box flex={1}>
                        <Divider flexItem textAlign="center" sx={{ marginBottom: '15px' }}><b style={labelStyle}><Chip sx={{ fontSize: '1.2em' }} label="Course Management" /></b></Divider>
                    </Box>
                </Box>
                <RichTextInput source="courseManagement" label={false} fullWidth />
                <Box display="flex" width={1}>
                    <Box flex={1}>
                        <Divider flexItem textAlign="center" sx={{ marginBottom: '15px' }}><b style={labelStyle}><Chip sx={{ fontSize: '1.2em' }} label="Transitional Arrangements" /></b></Divider>
                    </Box>
                </Box>
                <RichTextInput source="transitionalArrangements" label={false} fullWidth />
                <Box display="flex" width={1}>
                    <Box flex={1}>
                        <Divider flexItem textAlign="center" sx={{ marginBottom: '15px' }}><b style={labelStyle}><Chip sx={{ fontSize: '1.2em' }} label="Arrangements for Feedback to Students" /></b></Divider>
                    </Box>
                </Box>
                <RichTextInput source="arrangementsForFeedbackToStudents" label={false} fullWidth />
                <Box display="flex" width={1}>
                    <Box flex={1}>
                        <Divider flexItem textAlign="center" sx={{ marginBottom: '15px' }}><b style={labelStyle}><Chip sx={{ fontSize: '1.2em' }} label="Student Representation" /></b></Divider>
                    </Box>
                </Box>
                <RichTextInput source="studentRepresentation" label={false} fullWidth />
                <Box display="flex" width={1}>
                    <Box flex={1}>
                        <Divider flexItem textAlign="center" sx={{ marginBottom: '15px' }}><b style={labelStyle}><Chip sx={{ fontSize: '1.2em' }} label="Course Monitoring" /></b></Divider>
                    </Box>
                </Box>
                <RichTextInput source="courseMonitoring" label={false} fullWidth />
                <Box display="flex" width={1}>
                    <Box flex={1}>
                        <Divider flexItem textAlign="center" sx={{ marginBottom: '15px' }}><b style={labelStyle}><Chip sx={{ fontSize: '1.2em' }} label="External Examiner" /></b></Divider>
                    </Box>
                </Box>
                <RichTextInput source="externalExaminer" label={false} fullWidth />

                <Box display="flex" width={1}>
                    <Box flex={1}>
                        <Divider flexItem textAlign="center" sx={{ marginBottom: '15px' }}><b style={labelStyle}><Chip sx={{ fontSize: '1.2em' }} label="Quality Standard Indicators / Methods" /></b></Divider>
                    </Box>
                </Box>

                <RichTextInput source="methodsOfQualityStandards" label="Methods for evaluating and improving the quality and standards of learning and teaching" fullWidth />

                <RichTextInput source="qualityOfStandardsIndicators" label="Indicators of quality and standards" fullWidth />

                {resource === "Course" &&
                    <VersioningTypeInput source="versioningType" resource={resource} />

                }

    </FormTab>

}



export const CourseQualityAssuranceArrangementsShowTab = (source) =>
    <Tab label="Course QAA" {...source} >
        <RichTextField source="courseManagement" label="Course Management" />
        <RichTextField source="transitionalArrangements" />
        <RichTextField source="arrangementsForFeedbackToStudents" label="Arrangements for Feedback to Students" />
        <RichTextField source="studentRepresentation" label="Student Representation" />
        {/*<RichTextField source="engagementWithSubjectBenchmarkStatement" label="Engagement with Subject Benchmark Statement"/>   */}
        <RichTextField source="courseMonitoring" label="Course Monitoring" />
        <RichTextField source="eternalExaminerId" label="External Examiner" />
    </Tab>
